module.exports = __webpack_public_path__ + "static/azuth-symbol-SCAG-19fcd140373016f0f59b5417fe0d819d.webp";